import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const EmptyStateMessage = ({
  icon: Icon,
  message,
  iconSize = 32,
  iconProps,
  sx,
  messageProps,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: theme.palette.text.secondary,
        ...sx,
      }}
    >
      {Icon && (
        <Icon
          size={iconSize}
          style={{
            marginBottom: "12px",
            opacity: 0.5,
            color: theme.palette.text.secondary,
            ...(iconProps?.style || {}),
          }}
          {...iconProps}
        />
      )}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 500,
          color: theme.palette.text.secondary,
        }}
        {...messageProps}
      >
        {message}
      </Typography>
    </Box>
  );
};

EmptyStateMessage.propTypes = {
  icon: PropTypes.elementType,
  message: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  iconProps: PropTypes.object,
  sx: PropTypes.object,
  messageProps: PropTypes.object,
};

EmptyStateMessage.defaultProps = {
  icon: null,
  iconSize: 32,
  iconProps: {},
  sx: {},
  messageProps: {},
};

export default EmptyStateMessage;
